module.exports = __webpack_public_path__ + "static/img/eyes.a94b009e.svg";